module.exports = __webpack_public_path__ + "img/img_brand15.4935334e.jpg";